export * from './stream-analysis-service';
